import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Commodities from "./components/Commodities";
import TradeFlow from "./components/TradeFlow";
import Services from "./components/Services";
import WhyVynex from "./components/WhyVynex";
import Contact from "./components/Contact";

const HomePage = () => {
  return (
    <main className="App relative">
      <Navbar />
      <Hero />
      <About />
      <Commodities />
      <TradeFlow />
      <Services />
      <WhyVynex />
      <Contact />
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#061b33",
            color: "#ffffff",
            border: "1px solid #c99a3a",
            borderRadius: 0,
          },
        }}
      />
    </main>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
